export default __webpack_public_path__ + "static/media/salmon.2ce4a3fe.jpeg";